import { useSelector } from 'react-redux';

export function useIsPreview() {
  return useSelector((state: AppState) => state?.globals?.server?.isPreview);
}
